import { type AppEnvironment } from '../config/app-environment';
import { EnvironmentService } from '../config/environment.service';
import { useContainer } from './useContainer';

export const useEnvironment = (): AppEnvironment => {
  const container = useContainer();
  return container.get(EnvironmentService<AppEnvironment>).environment;
};
